const PROD_API_URL = 'https://lender-api-prd.herokuapp.com/api'
const DEV_API_URL = 'https://lender-api-dev.herokuapp.com/api'
const LOCAL_API_URL = 'http://localhost:3000/api'
const { hostname } = window.location
const LOCAL_HOSTNAME = 'localhost'
const DEV_HOSTNAME = 'dev.lending-well.com'

const getApiBaseURL = () => {
  if (hostname.includes(LOCAL_HOSTNAME)) return LOCAL_API_URL
  if (hostname.includes(DEV_HOSTNAME)) return DEV_API_URL
  return PROD_API_URL
}

export const API_BASE_URL = getApiBaseURL()
